import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Dialog from "material-ui/Dialog";
import {
    duplicateClass,
    getTeacherArchivedClasses,
    unarchiveTeacherClass,
} from "../../../redux";
import "../../Components/dashboard.css";
import "../ManageClasses/ClassTile/index.css";
import "./index.css";

function ManageArchivedClasses(props) {
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [archivedClassToView, setArchivedClassToView] = useState(null);
    const [archivedClassViewData, setArchivedClassViewData] = useState({
        loading: false,
        assignments: [],
        sprints: [],
        evaluations: [],
        error: "",
    });
    const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);
    const [archivedClassToDuplicate, setArchivedClassToDuplicate] = useState(null);
    const [duplicateForm, setDuplicateForm] = useState({ name: "", status: "" });

    useEffect(() => {
        window.scrollTo(0, 0);
        props.getTeacherArchivedClasses(props.user._id);
    }, []);

    const archivedClassesList = Array.isArray(props.teacherArchivedClasses)
        ? props.teacherArchivedClasses
        : [];

    const handleRestoreArchived = (classObject) => {
        props.unarchiveTeacherClass(props.user._id, classObject._id);
    };

    const handleViewArchived = (classObject) => {
        setArchivedClassToView(classObject);
        setViewDialogOpen(true);
        setArchivedClassViewData({
            loading: true,
            assignments: [],
            sprints: [],
            evaluations: [],
            error: "",
        });
        const token = localStorage.token;
        Promise.all([
            fetch(`/api/class/${classObject._id}/assignment`, {
                headers: { Authorization: `Bearer ${token}` },
            }).then((r) => (r.ok ? r.json() : Promise.reject(r))),
            fetch(`/api/class/${classObject._id}/sprint`, {
                headers: { Authorization: `Bearer ${token}` },
            }).then((r) => (r.ok ? r.json() : Promise.reject(r))),
            fetch(`/api/class/assignment/student/${classObject._id}`, {
                headers: { Authorization: `Bearer ${token}` },
            }).then((r) => (r.ok ? r.json() : Promise.reject(r))),
        ])
            .then(([assignments, sprints, evaluations]) => {
                setArchivedClassViewData({
                    loading: false,
                    assignments: assignments || [],
                    sprints: sprints || [],
                    evaluations: evaluations || [],
                    error: "",
                });
            })
            .catch(() => {
                setArchivedClassViewData((prev) => ({
                    ...prev,
                    loading: false,
                    error: "Could not load archived class details.",
                }));
            });
    };

    const handleDuplicateArchivedClick = (classObject) => {
        setArchivedClassToDuplicate(classObject);
        setDuplicateForm({ name: "", status: "" });
        setDuplicateDialogOpen(true);
    };

    const handleDuplicateConfirm = () => {
        if (archivedClassToDuplicate && duplicateForm.name.trim() && duplicateForm.status.trim()) {
            props.duplicateClass(archivedClassToDuplicate._id, duplicateForm);
        }
        setDuplicateDialogOpen(false);
        setArchivedClassToDuplicate(null);
        setDuplicateForm({ name: "", status: "" });
    };

    return (
        <div className="dashboard">
            <div className="archivedClassesPage">
                <Link to="/manage/classes" className="backButton">
                    <img src={require("../../../Images/leftArrow.png")} alt="" />
                    Back to Manage Classes
                </Link>

                <header className="archivedClassesHero">
                    <h1 className="archivedClassesTitle">Archived Classes</h1>
                    <p className="archivedClassesLead">
                        These classes are hidden from students. Open one to see a quick summary, restore it to your active list, or duplicate it into a new class.
                    </p>
                </header>

                <h2 className="archivedClassesSectionLabel">Your archived classes</h2>

                {archivedClassesList.length === 0 ? (
                    <p className="archivedClassesEmpty" role="status">
                        No archived classes yet. When you archive a class from Manage Classes, it will appear here.
                    </p>
                ) : (
                    <div className="archivedClassesGrid">
                        {archivedClassesList.map((classObject, index) => (
                            <div className="classTileContainer" key={index + classObject.name + "_archived"}>
                                <div className="classTile">
                                    <h1>{classObject.name}</h1>
                                    <h3>{classObject.status}</h3>
                                    <button type="button" onClick={() => handleViewArchived(classObject)} className="pink">
                                        View
                                    </button>
                                    <button type="button" onClick={() => handleRestoreArchived(classObject)} className="pink">
                                        Restore
                                    </button>
                                    <button type="button" onClick={() => handleDuplicateArchivedClick(classObject)} className="pink">
                                        Duplicate
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <Dialog open={viewDialogOpen} onRequestClose={() => setViewDialogOpen(false)}>
                <div>
                    <h3>{archivedClassToView ? archivedClassToView.name : "Archived class"}</h3>
                    <p>This class is archived (view-only).</p>
                    {archivedClassViewData.loading ? (
                        <p>Loading…</p>
                    ) : (
                        <div style={{ marginTop: "12px" }}>
                            <p>
                                Assignments: <strong>{archivedClassViewData.assignments.length}</strong>
                            </p>
                            <p>
                                Sprints: <strong>{archivedClassViewData.sprints.length}</strong>
                            </p>
                            <p>
                                Evaluations: <strong>{archivedClassViewData.evaluations.length}</strong>
                            </p>
                            {archivedClassViewData.error ? (
                                <p className="errorMessage">{archivedClassViewData.error}</p>
                            ) : null}
                        </div>
                    )}
                    <div style={{ display: "flex", justifyContent: "flex-end", padding: "20px 10px" }}>
                        <button type="button" onClick={() => setViewDialogOpen(false)} className="actionButton">
                            Close
                        </button>
                    </div>
                </div>
            </Dialog>

            <Dialog open={duplicateDialogOpen} onRequestClose={() => setDuplicateDialogOpen(false)}>
                <div>
                    <h3>Duplicate archived class</h3>
                    <p>{archivedClassToDuplicate ? `Source: ${archivedClassToDuplicate.name}` : ""}</p>
                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "12px" }}>
                        <input
                            type="text"
                            placeholder="New class name"
                            value={duplicateForm.name}
                            onChange={(e) => setDuplicateForm({ ...duplicateForm, name: e.target.value })}
                            style={{ padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                        />
                        <input
                            type="text"
                            placeholder="Status (Active or Closed)"
                            value={duplicateForm.status}
                            onChange={(e) => setDuplicateForm({ ...duplicateForm, status: e.target.value })}
                            style={{ padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                        />
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", padding: "20px 10px", gap: "24px" }}>
                        <button type="button" onClick={() => setDuplicateDialogOpen(false)} className="actionButton">
                            Cancel
                        </button>
                        <button type="button" className="actionButton" onClick={handleDuplicateConfirm}>
                            Duplicate
                        </button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(state => state.root, {
    duplicateClass,
    getTeacherArchivedClasses,
    unarchiveTeacherClass,
})(ManageArchivedClasses);
